'use strict';

var base = require('base/search/search');
var utils = require('pagedesigner/util/utils');
var filterBarCarousel = require('org/components/filterBarCarousel');

var previousCollapsedStates = [];

/**
 * Close the refinements window
 *
 */
function applyRefinements() {
    $('.apply-refinements').on('click', function () {
        base.closeRefinements();
    });
}

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    if (selector === '.grid-header' || selector === '.filter-bar-carousel') {
        filterBarCarousel.clearInitFlags();
    }
    $(selector).empty().html($updates.html());

    // Handling Sale / Clearance color swatch visibility on tiles
    var saleRefinementSelected = $('.on-sale-button').hasClass('selected');
    var clearanceRefinementSelected = $('.on-clearance-button').hasClass('selected');
    $('.product-grid').toggleClass('on-sale-selected', saleRefinementSelected);
    $('.product-grid').toggleClass('on-clearance-selected', clearanceRefinementSelected);

    // Handling Color Selection swatch visibility on tiles
    var colorRefinementSelected = $('.refinements .color-attribute .swatch-circle').hasClass('selected');
    var colorRefinementsButton = $('.filter-bar .btn-swatch-color').data('color');
    $('.product-grid').toggleClass('color-selected', colorRefinementSelected, colorRefinementsButton);

    if (selector === '.product-grid') {
        $(document.body).trigger('tileImageCarousel:init');
    }
}

/**
 * Toggle Color Swatches based on Color Refinenment
 *
 */
function toggleColorSwatches() {
    /* var excludeClasses = ['row', 'no-gutters', 'product-grid', 'row-cols-1', 'row-cols-2', 'row-cols-md-3', 'row-cols-md-4', 'row-cols-md-5', 'color-selected', 'on-sale-selected', 'on-clearance-selected'];
    var colorSwatchItems = $('.product-tile .swatches a.color-attribute span');
    var selectedSwatches = $('.product-grid').attr('class').trim().split(/\s+/);
    selectedSwatches = selectedSwatches.filter((elem) => !excludeClasses.includes(elem));

    if ($('.product-grid').hasClass('color-selected')) {
        colorSwatchItems.each(function () {
            for (var i = 0; i < selectedSwatches.length; i++) {
                if (!$(this).hasClass(selectedSwatches[i])) {
                    $(this).parent().toggleClass('inactive');
                    break;
                }
            }
        });
    } else {
        for (var i = 0; i < selectedSwatches.length; i++) {
            $('.product-grid').removeClass(selectedSwatches[i]);
        }
    } */
}

/**
 * Set refinement opened/collapsed state
 *
 * @param {Object} $refinement - jQuery DOM element
 * @param {boolean} desktopCollapsed - desktop collapsed flag
 * @param {boolean} mobileCollapsed - mobile collapsed flag
 */
function toggleRefinementCollapsedState($refinement, desktopCollapsed, mobileCollapsed) {
    // Desktop
    if (desktopCollapsed) {
        $refinement.find('.card-header .desktop-view .btn').attr('aria-expanded', 'false').addClass('collapsed');
        $refinement.find('.collapse.desktop-view').removeClass('show');
    } else {
        $refinement.find('.card-header .desktop-view .btn').attr('aria-expanded', 'true').removeClass('collapsed');
        $refinement.find('.collapse.desktop-view').addClass('show');
    }
    // Mobile
    if (mobileCollapsed) {
        $refinement.find('.card-header .mobile-view .btn').attr('aria-expanded', 'false').addClass('collapsed');
        $refinement.find('.collapse.mobile-view').removeClass('show');
    } else {
        $refinement.find('.card-header .mobile-view .btn').attr('aria-expanded', 'true').removeClass('collapsed');
        $refinement.find('.collapse.mobile-view').addClass('show');
    }
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement').each(function () {
        var $this = $(this);
        var selector = '.' + $this[0].className.replace(/ /g, '.');
        var $activeDiv = $results.find(selector);
        var isDesktopCollapsed = $('.card-header .desktop-view .btn', $this).hasClass('collapsed');
        var isMobileCollapsed = $('.card-header .mobile-view .btn', $this).hasClass('collapsed');
        if ($activeDiv.length) {
            toggleRefinementCollapsedState($activeDiv, isDesktopCollapsed, isMobileCollapsed);
        } else {
            // Save current open/collapsed state
            previousCollapsedStates.push({
                selector: selector,
                isDesktopCollapsed: isDesktopCollapsed,
                isMobileCollapsed: isMobileCollapsed
            });
        }
    });

    // Set previous open/collapsed state for returning refinements
    if (previousCollapsedStates.length) {
        $('.refinement', $results).each(function () {
            var $this = $(this);
            var selector = '.' + $this[0].className.replace(/ /g, '.');
            var index = previousCollapsedStates.findIndex(r => r.selector === selector);
            if (index >= 0) {
                toggleRefinementCollapsedState($this, previousCollapsedStates[index].isDesktopCollapsed, previousCollapsedStates[index].isMobileCollapsed);
                // Remove previous state once applied
                previousCollapsedStates.splice(index, 1);
            }
        });
    }

    updateDom($results, '.refinements');

    // when loading the refinement selections, scroll to top of results container for a better UI
    var scrollOffset = utils.mediaBreakpointDown('sm') ? 140 : 108;
    $('html, body').animate({
        scrollTop: $('#product-search-results').offset().top - scrollOffset
    }, 500);
}

/**
 * Keep selected options on grid header after ajax call
 *
 * @param {Object} $results - jQuery DOM element
 */
function handleGridHeader($results) {
    var activeGridModeDesktop = $('.js-grid-toggle.active').data('gridmode');
    var activeGridModeMobile = $('.js-grid-toggle-mobile.active').data('gridmode');

    $results.find(`[data-gridmode=${activeGridModeDesktop}], [data-gridmode=${activeGridModeMobile}]`).addClass('active').siblings().removeClass('active');

    updateDom($results, '.grid-header');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements,
        '.grid-header': handleGridHeader
    };

    // Update DOM elements that do not require special handling
    [
        '.search-banner:first-of-type',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.filter-bar-carousel',
        '.items-count',
        '.mobile-refinement',
        '.on-sale-refinement'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    $(document.body).trigger('grid:updated');

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

/**
 * Filters Bar Mobile functions
 */
function mobileFiltersFunctions() {
    // Mobile: Save refinements scroll postion
    if ($('.refinements').hasClass('all-active') && localStorage.refinementScrollPos) {
        var refinementScrollPos = JSON.parse(localStorage.getItem('refinementScrollPos'));
        $.each(refinementScrollPos, function (k, v) {
            $('.' + k).find('#' + k + '-mobile .card-body').scrollTop(v);
        });
    }

    // Toggle Clear All button (.clear-all-btn)
    var mobileRefinements = $('ul.mobile-refinement li').length;
    if (mobileRefinements === 0) {
        $('.clear-all-btn').addClass('d-none');
    } else {
        $('.clear-all-btn').removeClass('d-none');
    }

    filterBarCarousel.init();
}

/**
 * Calculates page number based on start and sz parameters and
 * Adds page parameter and push new state to the browser history
 *
 * @param {string} showMoreUrl - show more url with start and sz parameters
 */
function pushState(showMoreUrl) {
    var showMoreParams = utils.getQueryStringParams(showMoreUrl);
    if (showMoreParams.start && showMoreParams.sz) {
        var page = showMoreParams.start / showMoreParams.sz;
        var newUrl = utils.removeParamFromURL(window.location.href, 'page');
        newUrl = utils.appendParamToURL(newUrl, 'page', page);

        var stateData = {
            path: newUrl,
            scrollTop: $(window).scrollTop()
        };
        window.history.pushState(stateData, document.title, newUrl);
    }
}


/**
 * Handles the response from the sorting call.
 * Replaces the grid footer with the response content, stops the spinner, and triggers the tileImageCarousel:init event.
 * Pushes a new state to the browser history with the sorting parameters.
 *
 * @param {string} response - The response content from the server.
 * @param {string} target - The target URL for the sorting.
 */
var sortResponseHandler = function (response) {
    $('.grid-footer').parent().html(response);
    toggleColorSwatches();
    $.spinner().stop();
    // $(document.body).trigger('grid:updated');
    $(document.body).trigger('tileImageCarousel:init');
};


/**
 * Handles the response from the filtering call.
 * Replaces the results with the response content, stops the spinner, and triggers the mobileFiltersFunctions event.
 * Pushes a new state to the browser history with the filter parameters.
 *
 * @param {string} response - The response content from the server.
 * @param {string} updatedURL - The URL for the updated page.
 * @param {string} updatedParams - The query string parameters for the filter.
 * @param {string} urlAnalytic - The analytics parameters to add to the URL.
 */
var filterResponseHandler = function (response) {
    parseResults(response);
    toggleColorSwatches();
    mobileFiltersFunctions();
    $.spinner().stop();
    if ($('.refinement-bar').hasClass('show')) {
        filterBarCarousel.scheduleFocusDrawerCloseApplyAfterAjax();
    }
};

/**
 * Apply Sorting
 *
 * @param {string} v - url
 * @param {string} p - url parameters
 * @param {string} i - data-id
 */
function sortFunction(v, p, i) {
    var thisValue = v;
    var thisParams = p;
    var thisDataId = i;

    $.spinner().start();
    $(this).trigger('search:sort', thisValue);

    $('.sort-button, [name=sort-order] option').each(function () {
        $(this).not('buttom').removeAttr('selected');
        $(this).removeClass('selected');

        if ($(this).data('id') === thisDataId) {
            $(this).not('button').attr('selected', 'selected');
            $(this).addClass('selected');
        }
    });
    // remove sz param
    thisParams = utils.removeParamFromURL(thisValue, 'sz');
    // get query string
    const source = new URL(thisParams);
    const target = new URL(location.protocol + '//' + location.host + location.pathname);

    // Get the query parameters from the source URL
    source.searchParams.forEach((value, key) => {
        // Add each parameter to the target URL
        target.searchParams.append(key, value);
    });

    $.ajax({
        url: thisParams,
        data: {
            selectedUrl: thisParams,
            page: 0
        },
        method: 'GET',
        success: function (response) {
            sortResponseHandler(response, target, thisParams);
            window.history.pushState({
                theUrl: thisParams,
                type: 'sort',
                scrollPosition: $(window).scrollTop(),
                refinementStateHtml: $('.refinement-bar').html(),
                gridHeaderHtml: $('.grid-header').html()
            }, document.title, target.toString());
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Clear selection of PLP filter
 */
function clearPlpFilters() {
    $('.plp-filtering-link').each(function () {
        $(this).removeClass('disabled');
        $(this).find('.img-tile-default').each(function () {
            var newSrc = $(this).attr('data-src').replace('_active', '_default');
            $(this).attr({
                'data-src': newSrc,
                src: newSrc
            });
        });
    });
}

/**
 * Mobile: On scroll, stick mobile refinement bar to header
 */
function stickMobileRefinementBar() {
    var scroll = $(window).scrollTop();
    var headerHeight = $('.site-header').outerHeight();
    var offsetHeader = $('.header-banner').length ? $('.header-banner').outerHeight() : 0;
    var offsetFilters = $('.dark-stripe').length ? $('.dark-stripe').outerHeight() : 0;
    var filtersHeight = $('#mobile-filters-wrap').outerHeight();

    if ((scroll - offsetHeader) >= offsetFilters && utils.mediaBreakpointDown('sm')) {
        $('#mobile-filters-wrap').addClass('is-sticky').css('margin-top', headerHeight);
        $('#product-search-results').css('padding-top', filtersHeight);
    } else {
        $('#mobile-filters-wrap').removeClass('is-sticky').removeAttr('style');
        $('#product-search-results').removeAttr('style');
    }
}

/**
 * Toggle grid button on PLP page
 *
 */
function gridToggleBtn() {
    let gridToggleActive = localStorage.getItem('grid-toggle-active-state');
    if (gridToggleActive !== null && gridToggleActive !== '') {
        let gridButton = $('[data-gridmode = ' + gridToggleActive + ']');
        let $grid = $('.product-grid');
        gridButton.addClass('active').siblings('.js-grid-toggle, .js-grid-toggle-mobile').removeClass('active');

        if (gridButton.hasClass('js-grid-toggle-mobile')) {
            $grid.removeClass('row-cols-1 row-cols-2').addClass(gridToggleActive);
        } else {
            $grid.removeClass('row-cols-md-3 row-cols-md-4 row-cols-md-5').addClass(gridToggleActive);
        }
    }
}

module.exports = $.extend(base, {
    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(document.body).on('click', 'button.open-refinement', function () {
            var label = $(this).attr('aria-label');
            var elem = $(this).data('elem');
            var activeRefinement = { label: label, elem: elem };
            localStorage.setItem('mobileActiveRefinement', JSON.stringify(activeRefinement));

            $('.card.refinement').each(function () {
                $(this).removeClass('d-flex');
            });

            if ($(this).hasClass('filter-results')) {
                $('.refinements').addClass('all-active');
            } else {
                $('.card.refinement.' + elem).addClass('d-flex');
            }

            if (elem === 'refinement-sort') {
                $('.mobile-refinement-wrap, .result-count').addClass('d-none');
            } else {
                $('.mobile-refinement-wrap, .result-count').removeClass('d-none');
            }

            $('.header-bar h2.filter').text(label);
            $(document.body).css('overflow-y', 'hidden');
            $('.refinement-bar').addClass('show');
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.search-results').siblings().attr('aria-hidden', true);
            filterBarCarousel.scheduleFocusRefinementBlock(elem);
        });
        // Added Scrolltop effect for last filter result
        $(document.body).on('click', '.refinement-bar .refinements .card.refinement:last-child() .card-header .mobile-view button.collapsed', function () {
            setTimeout(function () {
                var refinementDiv = $('.refinement-bar .refinements').height();
                $('.refinements-wrapper').animate({ scrollTop: refinementDiv }, 500);
            }, 200);
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $(document.body).on('click', '.refinement-bar button.close-refinement, .refinement-bar button.apply', function () {
            $(document.body).removeAttr('style');
            var activeElem = null;
            try {
                var storedRefinement = localStorage.getItem('mobileActiveRefinement');
                if (storedRefinement) {
                    activeElem = JSON.parse(storedRefinement).elem;
                }
            } catch (e) {
                activeElem = null;
            }
            var keys = ['refinementScrollPos', 'mobileActiveRefinement'];
            keys.forEach(k => localStorage.removeItem(k));

            $('.refinement-bar').removeClass('show');
            setTimeout(function () {
                $('.mobile-refinement-wrap, .result-count').removeClass('d-none');
                $('.refinements').removeClass('all-active');
                $('.card.refinement').each(function () {
                    $(this).removeClass('d-flex');
                });
                filterBarCarousel.focusFilterBarTrigger(activeElem);
            }, 250);

            $('.refinement-bar').siblings().removeAttr('aria-hidden');
            $('.refinement-bar').closest('.row').siblings().removeAttr('aria-hidden');
            $('.refinement-bar').closest('.tab-pane.active').siblings().removeAttr('aria-hidden');
            $('.refinement-bar').closest('.search-results').siblings().removeAttr('aria-hidden');
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(document.body).on('change', '[name=sort-order]', function (e) {
            e.preventDefault();
            var thisValue = this.value;
            var thisParams = this.value.split('?')[1];
            var thisDataId = $(this).find('option:selected').data('id');
            sortFunction(thisValue, thisParams, thisDataId);
        });
    },

    sortMobile: function () {
        // Handle sort order menu selection for Mobile View
        $(document.body).on('click', '.sort-button', function (e) {
            e.preventDefault();
            var thisValue = $(this).data('value');
            var thisParams = thisValue.split('?')[1];
            var thisDataId = $(this).data('id');
            sortFunction(thisValue, thisParams, thisDataId);
        });
    },

    changePage: function () {
        // Show more products
        const handler = function (e, state) {
            e.stopPropagation();
            e.preventDefault();
            var pageUrl = $(this).data('url') || $(this).val() || (state && state.theUrl);

            const element = document.getElementById('product-search-results');
            if (element && !state) {
                element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
            $.spinner().start();
            $.ajax({
                url: pageUrl,
                data: { selectedUrl: pageUrl },
                method: 'GET',
                success: function (response) {
                    $.spinner().stop();
                    $('.grid-footer').parent().html(response);
                    updateSortOptions(response);

                    var showMoreParams = utils.getQueryStringParams(pageUrl);
                    if ('URLSearchParams' in window && !state) {
                        const url = new URL(window.location);
                        url.searchParams.set('page', showMoreParams.page || 1);
                        window.history.pushState({
                            theUrl: pageUrl,
                            type: 'page',
                            scrollPosition: $(window).scrollTop(),
                            refinementStateHtml: $('.refinement-bar').html(),
                            gridHeaderHtml: $('.grid-header').html()
                        }, document.title, url.toString());
                    }
                    if (state && state.refinementStateHtml) {
                        $('.refinement-bar').html(state.refinementStateHtml);
                    }
                    if (state && state.gridHeaderHtml) {
                        $('.grid-header').html(state.gridHeaderHtml);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        };
        window.addEventListener('popstate', function (e) {
            // if the state is the page you expect, pull the name and load it.
            if (e.state && e.state.theUrl) {
                switch (e.state.type) {
                    case 'sort':
                        $.spinner().start();
                        $.ajax({
                            url: e.state.theUrl,
                            data: {
                                page: 0,
                                selectedUrl: e.state.theUrl
                            },
                            method: 'GET',
                            success: function (response) {
                                sortResponseHandler(response);
                                if (e.state.scrollPosition) {
                                    window.scrollTo(0, e.state.scrollPosition);
                                }
                                if (e.state.refinementStateHtml) {
                                    $('.refinement-bar').html(e.state.refinementStateHtml);
                                }
                                if (e.state.gridHeaderHtml) {
                                    $('.grid-header').html(e.state.gridHeaderHtml);
                                }
                            },
                            error: function () {
                                $.spinner().stop();
                            }
                        });
                        break;
                    case 'page':
                        handler(e, e.state);
                        break;
                    case 'filter':
                        $.spinner().start();
                        $.ajax({
                            url: e.state.theUrl,
                            data: {
                                page: 0,
                                selectedUrl: e.state.theUrl
                            },
                            method: 'GET',
                            success: function (response) {
                                filterResponseHandler(response);
                                if (e.state.scrollPosition) {
                                    window.scrollTo(0, e.state.scrollPosition);
                                }
                            },
                            error: function () {
                                $.spinner().stop();
                            }
                        });
                        break;
                    default:
                }
            } else if (e.state === null) {
                // No state - let the browser handle navigation naturally
                window.location.reload();
            }
        });
        $('.plp-grid-column').on('change', 'select', handler);
        $('.plp-grid-column').on('click', '.plp-pagination .page-link-custom', handler);
        $('.plp-grid-column').on('shown.bs.dropdown', '.special-select', function () {
            var $dropdownMenu = $(this).find('.dropdown-menu');
            var $selectedItem = $dropdownMenu.find('.dropdown-item.selected');

            if ($selectedItem.length > 0) {
                $selectedItem.get(0).scrollIntoView({
                    block: 'center'
                });
            }
        });
    },
    applyFilter: function () {
        // Remove click event listener from container
        $('.container').off('click');
        // Handle refinement value selection and reset click
        $(document.body).on(
            'click',
            '.plp-filtering-link, .on-sale-button, .refinements li button:not(.sort-button), button.clear-refinements, .filter-value button, .swatch-filter button',
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                // Toggle the filter classes on product grid
                var $grid = $('.product-grid');
                var colorSelectionAlreadyApplied = $('.product-grid.color-selected');
                var $this = $(this);
                var swatchColor = $this.data('color');

                if (swatchColor && swatchColor.length > 0) {
                    if (colorSelectionAlreadyApplied.length > 0) {
                        if (colorSelectionAlreadyApplied.hasClass(swatchColor)) {
                            $grid.removeClass(swatchColor);
                        } else {
                            $grid.addClass(swatchColor);
                        }
                    } else {
                        $grid.addClass(swatchColor);
                    }
                }

                // Mobile: Save refinements scroll postion
                if ($('.refinements').hasClass('all-active')) {
                    var refinementScrollPos = {};
                    $('.card.refinement').each(function () {
                        var id = $(this).attr('id');
                        var pos = $(this).find('#' + id + '-mobile .card-body').scrollTop();
                        refinementScrollPos[id] = pos;
                    });
                    localStorage.setItem('refinementScrollPos', JSON.stringify(refinementScrollPos));
                }

                $.spinner().start();

                // Modifying the refinements link before call to add the active sorting rule parameter as SRFA OOTB doesn't keep Sort on refinement change
                var sortParam = new URLSearchParams($('.result-sort').find('[name=sort-order]').val()).get('srule');
                var urlSplit = $this.data('href').split('?');
                var updatedParams = new URLSearchParams(urlSplit[1]);
                var urlAnalytic = '';
                clearPlpFilters();
                if ($this.hasClass('plp-filtering-link')) {
                    $(this).trigger('plpFiltering');
                    urlSplit[0] = $this.data('url');

                    if (urlSplit[1].indexOf('icid=') >= 0 || urlSplit[1].indexOf('ecid=') >= 0) {
                        // Filtering by TCatE considering parameter for analytics
                        var regex = new RegExp(/(i|e)cid/);
                        var campaignParam = urlSplit[1].match(regex)[0];
                        urlAnalytic = '&' + campaignParam + '=' + updatedParams.get(campaignParam);
                        urlSplit[1] = urlSplit[1].split('&' + campaignParam)[0];
                        updatedParams.delete(campaignParam);
                    }
                }

                var currURLParams = new URLSearchParams(document.location.href.split('?')[1]);
                if (currURLParams.get('srule') || !currURLParams.get('q')) {
                    updatedParams.set('srule', sortParam);
                }
                updatedParams = updatedParams.toString();
                var updatedURL = urlSplit[0] + '?' + updatedParams;
                $this.trigger('search:filter', e);

                $.ajax({
                    url: updatedURL,
                    data: {
                        page: 0,
                        selectedUrl: updatedURL
                    },
                    method: 'GET',
                    success: function (response) {
                        filterResponseHandler(response);
                        window.history.pushState({
                            theUrl: updatedURL,
                            type: 'filter',
                            scrollPosition: $(window).scrollTop()
                        }, document.title, document.location.href.split('?')[0] + '?' + updatedParams + urlAnalytic);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            });
    },

    plpFiltering: function () {
        $('body').on('plpFiltering', function (e) {
            var $this = $(e.target);
            $this.closest('.experience-tileCarousel_E').find('a').removeClass('disabled');
            $this.closest('.experience-tileCarousel_E').find('picture.picture-tile').each(function () {
                var sources = $(this).find('source');
                sources.each(function () {
                    if ($(this).attr('srcset')) {
                        $(this).attr('srcset', $(this).attr('srcset').replace('_active', '_default'));
                    }
                    if ($(this).attr('data-src')) {
                        $(this).attr('data-src', $(this).attr('data-src').replace('_active', '_default'));
                    }
                });
                $this.find('.img-tile-default').attr('src').replace('_active', '_default');
            });

            $this.addClass('disabled');
            $this.find('picture.picture-tile').each(function () {
                var sources = $(this).find('source');
                sources.each(function () {
                    if ($(this).attr('srcset')) {
                        $(this).attr('srcset', $(this).attr('srcset').replace('_default', '_active'));
                    }
                    if ($(this).attr('data-src')) {
                        $(this).attr('data-src', $(this).attr('data-src').replace('_default', '_active'));
                    }
                });
                $this.find('.img-tile-default').attr('src').replace('_default', '_active');
            });
        });
    },

    colorAttribute: function () {
        // Swatches mouse over events on non-mobile devices to update tile images and PDP/QV URL based on each swatch variation
        if (!utils.isMobile()) {
            $(document.body).on('mouseenter', '.color-swatches .color-attribute[data-colorimage]', function () {
                var $this = $(this);
                var $parentTile = $this.parents('.product-tile');
                var variationURL = $this.attr('href');
                var $qvLink = $parentTile.find('a.quickview');

                var swatchImages = [
                    $this.data('colorimage'),
                    $this.data('colorimagehover')
                ];

                // Handle images loading/swap
                swatchImages.forEach(function (element, index) {
                    if (element) {
                        var newImage = new Image();

                        $(newImage).on('load', function () {
                            $parentTile.find('.tile-image').eq(index).attr('src', $(this).attr('src'));
                        });

                        newImage.src = swatchImages[index];
                    }
                });

                // Handle tile/qv links update
                if (variationURL) {
                    var productId = $parentTile.parent('.product').data('pid');
                    var colorId = $this.data('color-id');
                    var qvParams = `&pid=${productId}&dwvar_${productId}_color=${colorId}&ajax=true`;

                    $qvLink.attr('href', function (index, value) {
                        return value.split('&pid')[0] + qvParams;
                    });
                    $parentTile.find('a.image-pdp-link, .pdp-link a.link').attr('href', variationURL);
                }
            });
        }
    },

    showMoreLess: function () {
        applyRefinements();
    },

    productGridToggler: function () {
        $(document.body).on('click', '.js-grid-toggle-mobile, .js-grid-toggle', function (e) {
            e.preventDefault();
            var $this = $(this);
            var isMobileToggler = $this.is('.js-grid-toggle-mobile');
            var gridMode = $this.data('gridmode');
            var $grid = $('.product-grid');

            $this.addClass('active').siblings('.js-grid-toggle, .js-grid-toggle-mobile').removeClass('active');
            localStorage.setItem('grid-toggle-active-state', gridMode);

            if (isMobileToggler) {
                $grid.removeClass('row-cols-1 row-cols-2').addClass(gridMode);
            } else {
                $grid.removeClass('row-cols-md-3 row-cols-md-4 row-cols-md-5').addClass(gridMode);
            }
        });

        $(window).on('load', function () {
            gridToggleBtn();
        });
    },

    seoTextExpand: function () {
        $(document.body).on('click', '.show-seo-text', function () {
            $('.seo-text-wrapper').addClass('expanded');
        });
    },

    updateBrowserUrl: function () {
        // Update the PLP browser url with the ajax call parameters to support back button / refresh / shared link
        $(document.body).on('updateBrowserUrl', function (e, calledParams) {
            var updatedURL = document.location.href.split('?')[0] + '?' + calledParams;
            history.pushState(null, null, updatedURL);
        });
    },

    /**
     * Pushes new state to browser history on search:showMore event
     * which is fired when user clicks on show more button
     */
    initPushState: function () {
        $('body').on('search:showMore', function (e) {
            if (e.target && e.target.dataset && e.target.dataset.url) {
                pushState(e.target.dataset.url);
            }
        });
    },

    init: function () {
        mobileFiltersFunctions();
        toggleColorSwatches();
        stickMobileRefinementBar();
    },

    /**
     * On resize, checks if refinement-bar was previously open for Mobile.
     * Remove overflow-y from body on desktop, keep it for mobile.
     */
    resize: function () {
        utils.smartResize(function () {
            if ($('.refinement-bar').hasClass('show')) {
                if (utils.mediaBreakpointDown('sm')) {
                    $(document.body).css('overflow-y', 'hidden');
                } else if (!utils.mediaBreakpointDown('sm')) {
                    $(document.body).removeAttr('style');
                }
            }

            stickMobileRefinementBar();
        });
    },

    /**
     * Mobile: On scroll, stick mobile refinement bar to header
     */
    scroll: function () {
        $(window).on('scroll', function () {
            if (!$(document.body).hasClass('overflow-hidden')) {
                stickMobileRefinementBar();
            }
        });
    }
});
